// extracted by mini-css-extract-plugin
module.exports = {"borderBox":"SiderAdmin_borderBox__egOTJ","subtitulo":"SiderAdmin_subtitulo__1Qcr1","Link":"SiderAdmin_Link__oxzdb","iconos":"SiderAdmin_iconos__gcPIi"};